import { createSlice } from "@reduxjs/toolkit";
import { selectedService } from "../../../types/service";
import { bookingGiftCard } from "../../../types/giftCard";
import { bookingMembership } from "../../../types/membership";
import { selectedPackages } from "../../../types/package";

const initialState = {
  services: {
    date: null as string | null,
    start_time: null as string | null,
    services: [] as selectedService[],
    packages: [] as selectedPackages[],
    coupon: null as string | null,
  },
  giftCards: {
    giftCards: [] as bookingGiftCard[],
    date: null as Date | null,
    coupon: null as string | null,
  },
  memberships: {
    startDate: null as string | null,
    coupon: null as string | null,
    memberships: [] as bookingMembership[],
  },
  client: {
    phoneNumber: null as string | null,
    phoneCountryCode: null as string | null,
    token: null as string | null,
    isAdmin: null as boolean | null,
    promoCode: null as {
      id: number;
      code: string;
      value: string;
      value_type: "percentage" | "price";
    } | null,
  },
  location: {
    id: null as number | null,
  },
};
const cartSlice = createSlice({
  name: "cart",
  initialState,
  reducers: {
    setServices: (state, action: { payload: selectedService[] }) => {
      state.services.services = action.payload;
    },
    setPackages: (state, action: { payload: selectedPackages[] }) => {
      state.services.packages = action.payload;
    },
    setDate: (state, action: { payload: string }) => {
      state.services.date = action.payload;
    },
    setStartTime: (state, action: { payload: string }) => {
      state.services.start_time = action.payload;
    },

    setCoupon: (state, action: { payload: string }) => {
      state.services.coupon = action.payload;
    },

    setGiftCards: (state, action: { payload: bookingGiftCard[] }) => {
      state.giftCards.giftCards = action.payload;
    },
    setMemberships: (state, action: { payload: bookingMembership[] }) => {
      state.memberships.memberships = action.payload;
    },
    setMembershipsStartDate: (state, action: { payload: string }) => {
      state.memberships.startDate = action.payload;
    },
    setClientPhoneNumber: (
      state,
      action: {
        payload: {
          phone: string | null;
          phone_country_code: string | null;
        };
      }
    ) => {
      state.client.phoneNumber = action.payload?.phone;
      state.client.phoneCountryCode = action.payload?.phone_country_code;
    },
    setToken: (state, action: { payload: string }) => {
      state.client.token = action.payload;
    },
    setAdmin: (state, action: { payload: boolean }) => {
      state.client.isAdmin = action.payload;
    },
    setLocationData: (state, action: { payload: { id: number | null } }) => {
      state.location = action.payload;
    },
    setPromoCode: (
      state,
      action: {
        payload: {
          id: number;
          code: string;
          value: string;
          value_type: "percentage" | "price";
        } | null;
      }
    ) => {
      state.client.promoCode = action.payload;
    },
    clearCart: (state) => {
      state.services = initialState.services;
      state.giftCards = initialState.giftCards;
      state.memberships = initialState.memberships;
      state.client = initialState.client;
      state.location = initialState.location;
    },
  },
});

export const {
  setServices,
  setDate,
  setStartTime,
  setCoupon,
  setGiftCards,
  setMemberships,
  setMembershipsStartDate,
  setClientPhoneNumber,
  setToken,
  setLocationData,
  clearCart,
  setAdmin,
  setPromoCode,
  setPackages,
} = cartSlice.actions;
export default cartSlice.reducer;
